





























import Vue from "vue";
import { ThisTypedComponentOptionsWithRecordProps } from "vue/types/options";
import { CombinedVueInstance } from "vue/types/vue";
import { Feature } from "../api/api";

export default {
  props: {
    data: {
      type: [Object, String],
      default: undefined,
    },
  },
} as ComponentOption;

export type ComponentOption = ThisTypedComponentOptionsWithRecordProps<
  Instance,
  Data,
  Methods,
  Computed,
  Props
>;

export type ComponentInstance = CombinedVueInstance<
  Instance,
  Data,
  Methods,
  Computed,
  Props
>;

export interface Instance extends Vue {}

export interface Data {}

export interface Methods {}

export interface Computed {}

export interface Props {
  data: Feature | undefined;
}
